import moment from "moment";
import {fnErrorMsg, fnToastrFormError, printResponse, resetForm} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnTerminateEmployee = function () {

    var tableName = '#datatable-customer-employees';
    var modal = $('#modal-terminate-employee');
    var form = $('#form-terminate-employee');
    var fullName = '';

    if (!element_exists(tableName)) return false;

    var lang = allLangFiles.termination.js;

    $(tableName + ' tbody ').off('click', '.btn-terminate').on('click', '.btn-terminate', function (e) {

        fullName = createTerminationForm(this, lang);
    });

    modal.find(':submit').off('click').on('click', function (e) {
        e.preventDefault();

        var title = lang.confirm_title + fullName;
        var confirmMsg = lang.confirm_msg + fullName + ':';
        var yesTxt = lang.yes;
        var noTxt = lang.no;

        //TODO validate fields that are visible

        $.confirm({
            title: title,
            content: confirmMsg,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Yes: {
                    text: yesTxt,
                    action: function () {
                        var data = form.serialize();

                        console.log(data);

                        $.ajax({
                            type: 'POST',
                            data: data,
                            url: '/employee/terminate/create',
                            success: function (response) {

                                printResponse(response);

                                $(tableName).DataTable().ajax.reload(null, false);
                                modal.modal('hide');
                            },
                            error: fnToastrFormError

                        });
                    }
                },
                No: {
                    text: noTxt
                }
            }
        });
    });

    modal.off().on('hidden.bs.modal', function () {
        resetForm(form);
        $('.additional-termination-fields').html('');
    });

    modal.find('.btn-cancel').off().on('click', function (e) {
        e.preventDefault();

        var employeeId = form.find('input[name=id]').val();
        var url = '/employee/terminate/' + employeeId + '/cancel';

        var title = lang.undo_title + fullName;
        var confirmMsg = lang.undo_msg;
        var yesTxt = lang.yes;
        var noTxt = lang.no;

        $.confirm({
            title: title,
            content: confirmMsg,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Yes: {
                    text: yesTxt,
                    action: function () {
                        $.ajax({
                            url: url,
                            success: function (response) {

                                printResponse(response);

                                $(tableName).DataTable().ajax.reload(null, false);
                                modal.modal('hide');
                            },
                            error: fnToastrFormError

                        });
                    }
                }, No: {
                    text: noTxt
                }
            }
        });
    });

    function createTerminationForm(row, lang) {

        var data = $(tableName).DataTable().row($(row).parents('tr')).data();
        var employeeId = data.id;
        var fullName = data.first_name + ' ' + data.last_name;
        var title = lang.input_title + fullName;
        var isNotHourlyAndNotBHonorarium = data.employment_type !== 'App\\Model\\Salary\\CustomerHourlyEmployee' && data.employment_type !== 'App\\Model\\Salary\\CustomerBHonorariumReceiverEmployee';
        var isTerminated = data.termination !== null;

        modal.find('.modal-title').html(title);

        form.find('input[name=id]').val(employeeId);

        moment.locale('da');

        var termination_date = data.termination === null ? '' : data.termination.termination_date;

        $('#termination_date').val(termination_date);


        if (isNotHourlyAndNotBHonorarium) {

            $('#notice_date').parents('.form-group').removeClass('hidden');
            $('#days_vacation_period').parents('.form-group').removeClass('hidden');

            var noticeDate = data.termination === null ? '' : data.termination.notice_date;

            $('#notice_date').val(noticeDate);

        }
        else {
            $('#notice_date').parents('.form-group').addClass('hidden');
            $('#days_vacation_period').parents('.form-group').addClass('hidden');
        }

        if (isNotHourlyAndNotBHonorarium && isTerminated) {
            form.find('input[name=days_vacation_period]').val(data.termination.days_vacation_period);
        }

        if (isTerminated) {
            modal.find('.btn-cancel').show();
        }
        else {
            modal.find('.btn-cancel').hide();
        }

        //Maybe return data
        return fullName;
    }
};
